module.exports = __webpack_public_path__ + "static/img/01.2a2a285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/01.jpg
// module id = QPWC
// module chunks = 0